import { tns } from "tiny-slider/src/tiny-slider";

for (let i = 0; i < $(".slider-min").length; i++) {
  sliderInit(i);
}

function sliderInit(i) {
  const id = $(".slider-min").eq(i).find(".slider-min__wrapper").data("id");

  let slider = tns({
    container: ".slider-min .slider-min__wrapper[data-id='" + id + "']",
    gutter: 10,
    nav: false,
    loop: false,
    speed: 800,
    controlsContainer: ".slider-min__control[data-id='" + id + "']",
    responsive: {
      0: {
        items: 1,
      },
      460: {
        items: 2,
      },
      768: {
        items: 3,
      },
      992: {
        items: 4,
      },
      1540: {
        items: 6,
      },
    },
  });
}
